import RhythmReplay from "../RhythmReplay";
import Stat from "./Stat";

const Bars = ({ title, list, slowest }) => (
  <div>
    <p className="label">{title}</p>
    <ul className="mt-3">
      {list.map((r) => (
        <li
          key={r.key}
          className="grid grid-cols-[1fr_auto] items-center gap-3 border-b border-[var(--line)] py-2.5"
        >
          <div className="min-w-0">
            <p className="truncate text-xs text-zinc-200">{r.label}</p>
            <div className="mt-1 h-[2px] w-full bg-[var(--line)]">
              <div
                className="h-full bg-zinc-400"
                style={{ width: `${Math.min(100, (r.mean_seconds / (slowest || 1)) * 100)}%` }}
              />
            </div>
          </div>
          <span className="font-data text-[10px] tabular-nums text-zinc-400">
            {r.mean_seconds}s
            <span className="ml-2 text-zinc-700">
              {r.vs_overall > 0 ? "+" : ""}
              {r.vs_overall}
            </span>
            <span className="ml-2 text-zinc-700">n{r.samples}</span>
          </span>
        </li>
      ))}
    </ul>
  </div>
);

const Split = ({ title, list }) => (
  <div>
    <p className="label">{title}</p>
    <ul className="mt-3">
      {list.map((r) => (
        <li
          key={r.key}
          className="flex items-baseline justify-between border-b border-[var(--line)] py-2"
        >
          <span className="text-xs text-zinc-300">{r.label}</span>
          <span className="font-data text-[10px] text-zinc-500">
            {r.mean_seconds}s · n{r.samples}
          </span>
        </li>
      ))}
    </ul>
  </div>
);

/** Answer timing: the turn-by-turn replay and the aggregate hesitation profile together. */
export const RhythmPanel = ({ m, subject }) => {
  const r = m?.rhythm;

  return (
    <div className="space-y-14" data-testid="admin-rhythm-panel">
      <RhythmReplay subject={subject} />

      <section className="border-t border-[var(--line)] pt-10">
        <p className="label">Answer speed by topic · hesitation is itself a signal</p>
        {!r?.overall ? (
          <p className="mt-4 font-data text-[11px] text-zinc-600">
            No rhythm samples yet. Timing is recorded from the next turn onward.
          </p>
        ) : (
          <>
            <div className="mt-6 grid grid-cols-2 gap-px bg-[var(--line)] sm:grid-cols-5">
              <Stat k="Turns timed" v={r.overall.turns} />
              <Stat k="Mean" v={`${r.overall.mean_seconds}s`} />
              <Stat k="Median" v={`${r.overall.median_seconds}s`} />
              <Stat k="Fastest" v={`${r.overall.fastest_seconds}s`} />
              <Stat k="Slowest" v={`${r.overall.slowest_seconds}s`} />
            </div>

            <div className="mt-8 grid gap-10 lg:grid-cols-2">
              <Bars
                title="Slowest topics · hesitation"
                list={r.by_category.slice(0, 8)}
                slowest={r.overall.slowest_seconds}
              />
              <Bars
                title="Fastest topics · fluency"
                list={[...r.by_category].reverse().slice(0, 8)}
                slowest={r.overall.slowest_seconds}
              />
            </div>

            <div className="mt-10 grid gap-10 lg:grid-cols-2">
              <Split title="By tier" list={r.by_tier} />
              <Split title="By phase" list={r.by_phase} />
            </div>
          </>
        )}
      </section>
    </div>
  );
};

export default RhythmPanel;
